import { render, staticRenderFns } from "./foodmeal.vue?vue&type=template&id=09b62f4b"
import script from "./foodmeal.vue?vue&type=script&lang=js"
export * from "./foodmeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports